export default __webpack_public_path__ + "static/media/grocery8.40805ec3.jpeg";